import { DASHBOARD_LINK_PARAM, type ActionScope } from '../actions/types'
import type { DashboardQuery } from './types'

/** Görev alt sayfaları — "Tümünü Gör" bağlantıları ilgili kapsam sayfasına götürür (analiz §2.3–§2.8). */
export const ACTIONS_BASE = '/minutes/actions'

/**
 * "Tümünü Gör" bağlantılarının **her hedefte ortak** olan parçası (2026-08-21, kullanıcı bildirimi:
 * "Tümünü Gör dediğimizde ilgili sayfanın filtresi çalışıp veriyle uyumlu olarak tabloda gösterilmeli").
 *
 * <ul>
 *   <li><b>Bayat süzgeç engeli</b> ({@link DASHBOARD_LINK_PARAM}) — bağlantı sorgusuz gittiğinde hedef
 *       ekran kullanıcının o kapsamda <b>en son</b> kullandığı görünümü ({@code sessionStorage}) geri
 *       yüklüyordu; bu işaretçi onu keser.
 *   <li><b>Sıralama</b> — panonun blokları termine göre artan; hedef liste varsayılanı oluşturma
 *       tarihidir. Bağlantı sıralamayı da taşır → ilk satırlar kartta görülenlerdir.
 * </ul>
 */
const VIEW_ALL_BASE = `${DASHBOARD_LINK_PARAM}=1&sortField=deadline&sortOrder=asc`

/**
 * Panonun etkin **dönem penceresi**, hedef listenin anladığı sorgu parçası olarak. Bu olmadan bağlantı,
 * panonun bir ayını sayan bir karttan <b>tüm zamanları</b> gösteren bir listeye götürüyordu (kullanıcı
 * bildirimi: kartta 3, tabloda 5 satır). Dönem → tarih aralığı çevrimini <b>sunucu</b> yapar (panoyla
 * tek kaynak), bu yüzden hazır tarih değil dönem anahtarı taşınır.
 */
export function periodParams(query: DashboardQuery): string {
  const parts = [`period=${query.period}`]
  if (query.period === 'CUSTOM' && query.startDate && query.endDate) {
    parts.push(`from=${query.startDate}`, `to=${query.endDate}`)
  }
  return parts.join('&')
}

/**
 * Bir pano bloğunun "Tümünü Gör" hedefi: kapsam sayfası + temiz görünüm + panonun dönemi + bloğun
 * kendi süzgeci.
 *
 * <p><b>Blok süzgeci neden bağlantıya eklenir:</b> panonun blokları hedef listede <b>karşılığı
 * olmayan</b> boyutlarda daralır. Somut şikâyet (2026-08-21): "Kalan Süre Dağılımı"nda 3 kayıt
 * görünürken bağlantı "Bana Atananlar"da 5 satır açıyordu. Bloğun ölçütü bu yüzden taşınır — Raporum'da
 * {@code overdue} / {@code upcoming} / {@code delegated}. {@code delegated} açıkken dönem penceresi
 * sunucuda <b>devir</b> tarihine uygulanır, görevin tarihine değil.
 *
 * @param filter bloğu tanımlayan ek süzgeç, başında `&` ile (ör. `'&overdue=true'`); yoksa boş.
 */
export function viewAllHref(scope: ActionScope, query: DashboardQuery, filter = ''): string {
  return `${ACTIONS_BASE}/${scope}?${VIEW_ALL_BASE}&${periodParams(query)}${filter}`
}
